import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/tailwind.css'
import '@/assets/css/custom.css'
import 'vue-awesome/icons/info'
import 'vue-awesome/icons/user-circle'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/sign-out-alt'
import 'vue-awesome/icons/angle-right'
import 'vue-awesome/icons/angle-double-right'
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/undo'
import 'vue-awesome/icons/external-link-alt'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/layer-group'
import 'vue-awesome/icons/expand-arrows-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/angle-double-left'
import 'vue-awesome/icons/angle-left'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/level-up-alt'
import 'leaflet/dist/leaflet.css'
import Icon from 'vue-awesome/components/Icon'
import VueClickaway from 'vue-clickaway'
import axios from 'axios'

Vue.component('v-icon', Icon)
Vue.directive('clickaway', VueClickaway.directive)

Vue.prototype.$http = axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
